import SectionTitle from '../../components/SectionTitle';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
  Text,
} from '@chakra-ui/react';

export default function TimelineSection() {
  return (
    <VStack w="100%" py="10">
      <SectionTitle title="Migration Timeline" />
      <Accordion allowMultiple w="100%">
        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <VStack align="start" flex="1" spacing="0">
              <Text fontWeight="light" fontSize="sm" color="whiteAlpha.800">
                January 14, 2025 (12:00 UTC)
              </Text>
              <Text>Liquidity removal</Text>
            </VStack>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              All LP providers should remove liquidity before this date. Exeedme will remove its own
              liquidity position on all decentralized exchanges in Ethereum, BNB Chain and Polygon,
              in the time above to prepare for the snapshot of all addresses.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <VStack align="start" flex="1" spacing="0">
              <Text fontWeight="light" fontSize="sm" color="whiteAlpha.800">
                January 14, 2025 (15:00 UTC)
              </Text>
              <Text>Snapshot of $XED holders balances</Text>
            </VStack>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              At this date we will collect all the $XED balances of all token holders and save it to
              create a whitelist for holders to claim the new tokens the day after. No transfers of
              $XED should be done after this point as they will not be taken into account for the
              claim of the new tokens.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <VStack align="start" flex="1" spacing="0">
              <Text fontWeight="light" fontSize="sm" color="whiteAlpha.800">
                January 14, 2025 (19:00 UTC)
              </Text>
              <Text>New $XED token & Staking Contract launched on Ethereum</Text>
            </VStack>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              There will be a Claim Portal available for old token holders to claim their new $XED
              tokens and Stake them. The old tokens will no longer be valid. The migration period
              begins on January 14th, 2025 at 12:00 UTC and will last until January 14th, 2026 at
              12:00 UTC.
            </Text>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </VStack>
  );
}
